import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL
const GET_TOKEN_URL = process.env.VUE_APP_GET_TOKEN_URL

export const request = (options) => {
    let headers = {
        'Content-Type': 'application/json'
    }

    if (options.headers) {
        headers = {...headers, ...options.headers}
        delete options["headers"]
    }

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options, {withCredentials: true})

    return axios(options)
            .then(res => {
                if (res.config.url.includes("/login")) throw Error("authenticated")
                return res
            })
}

export const getToken = (options) => {

    let data = new FormData()
    data.set('username', options.username)
    data.set('password', options.password)
    let populated_option = {
        url: GET_TOKEN_URL,
        headers : {
            'accountType': options.accountType,
            eventId: options.eventId
        },
        config: {
            headers: {'Content-Type': 'mutipart/form-data'}
        },
        method: 'post',
        data: data,
        withCredentials: true

    }
    return axios(populated_option)
}

export const recordMyPageAccess = options => {
  return request({
    url: API_BASE_URL + 'visitor/mypage/access/' + options.publishId,
    method: 'put',
    ...options
  })
}

export const sendPasswordResetToken = options => {
  return request({
    url: API_BASE_URL + 'forget',
    method: 'post',
    ...options
  })
}

export const isValidToken = options => {
  return request({
    url: API_BASE_URL + 'checkpwtoken',
    method: 'post',
    ...options
  })
}

export const resetPassword = options => {
  return request({
    url: API_BASE_URL + 'resetpw',
    method: 'post',
    ...options
  })
}

export const getMe = options => {
    return request({
        url: API_BASE_URL + 'visitor/me/' + options.headers.eventId,
        method: 'get',
        ...options
    })
}

export const applyEvent = options => {
    return request({
        url: API_BASE_URL + 'visitor/apply_event/',
        method: 'post',
        ...options
    })
}

export const getRegistrationStatus = options => {
  return request({
    url: API_BASE_URL + 'visitor/registration_status/' + options.publishId,
    method: 'get',
    ...options
  })
}

export const getEventId = options => {
  return request({
    url: API_BASE_URL + 'eventsite/' + options.publishId + '/id',
    method: 'get',
    ...options
  })
}

export const getEventSiteLocale = options => {
  return request({
    url: API_BASE_URL + 'eventsite/' + options.publishId + '/locale',
    method: 'get',
    ...options
  })
}

export const getEvent = options => {
    return request({
        url: API_BASE_URL + 'eventsite/' + options.publishId,
        method: 'get',
        ...options
    })
}

export const getMyPage = options => {
  return request({
    url: API_BASE_URL + 'mypage/' + options.publishId,
    method: 'get',
    ...options
  })
}

export const getTickets = options => {
  return request({
    url: API_BASE_URL + 'eventsite/tickets/' + options.eventId,
    method: 'get',
    ...options
  })
}

export const verifyPrivateSiteAccess = options => {
    console.log(options)
    return request({
        url: API_BASE_URL + 'eventsite/',
        method: 'post',
        ...options
    })
}

export const getEventSiteUrl = options => {
  return request({
    url: API_BASE_URL + 'eventsite/getUrl/' + options.eventId,
    method: 'get',
    ...options
  })
}

export const sendMailForMailAuth = options => {
  return request({
    url: API_BASE_URL + 'eventsite/send_mail_for_mail_auth',
    method: 'post',
    ...options
  })
}

export const doMailAuth = options => {
  return request({
    url: API_BASE_URL + 'eventsite/mail_auth'
      + `/${options.publishId}`
      + `/${options.token}`,
    method: 'get',
    ...options
  })
}

export const getJsonLdInfo = options => {
  return request({
    url: API_BASE_URL + 'eventsite/jsonld'
      + `/${options.publishId}`,
    method: 'get',
    ...options
  })
}

export const getOpenGraphInfo = options => {
  return request({
    url: API_BASE_URL + 'eventsite/opengraph'
      + `/${options.publishId}`,
    method: 'get',
    ...options
  })
}

export const getPayeesBankAccount = options => {
  return request({
    url: API_BASE_URL + 'eventsite/payees_bank_account'
      + `/${options.publishId}`,
    method: 'get',
    ...options
  })
}

export const signout = options => {
    return request({
        url: API_BASE_URL + 'logout',
        method: 'get',
        ...options
    })
}

export const cancelEvent = options => {
    return request({
        url: API_BASE_URL + 'visitor/me/' + options.eventId,
        method: 'delete',
        ...options
    })
}

export const getQrCode = options => {
    return API_BASE_URL + "visitor/qr/" + options.publicKey
}

export const updateVisitor = options => {
    return request({
        url: API_BASE_URL + 'visitor/update',
        method: 'post',
        ...options
    })
}

export const getSharedFiles = options => {
    return request({
        url: API_BASE_URL + 'file/' + options.eventId + '/shared',
        method: 'get',
        ...options
    })
}

export const getSharedVideos = options => {
  return request({
    url: API_BASE_URL + 'sharedvideo/mypage/' + options.eventId + '/allopen',
    method: 'get',
    ...options
  })
}

export const getTicketUrl = options => {
    return API_BASE_URL + 'visitor/' + options.eventId + '/ticket/' + options.locale
}

export const getTicketRemainCounts = options => {
    return request({
        url: API_BASE_URL + 'eventsite/' + options.eventId + '/ticket_remain_counts',
        method: 'get',
        ...options
    })
}

export const isPaymentEnable = options => {
    return request({
        url: API_BASE_URL + 'payment/eventsite/' + options.eventId + '/is_enable',
        method: 'get',
        ...options
    })
}

export const getSqEnvironment = options => {
    return request({
      url: API_BASE_URL + 'square/getEnvironment',
      method: 'get',
      ...options
    })
}

export const getSqPreOrderInfo = options => {
    return request( {
        url: API_BASE_URL + 'square/payment/pre_order_info/' + options.uuid,
        method: 'get',
        ...options
    })
}

export const doSqCharge = options => {
  return request( {
    url: API_BASE_URL + 'square/payment/charge',
    method: 'post',
    ...options
  })
}

export const getSbpsEnvironment = options => {
  return request({
    url: API_BASE_URL + 'sbps/getEnvironment',
    method: 'get',
    ...options
  })
}

export const getSbpsPreOrderInfo = options => {
  return request( {
    url: API_BASE_URL + 'sbps/payment/pre_order_info/' + options.uuid,
    method: 'get',
    ...options
  })
}

export const doSbpsTds2 = options => {
  return request( {
    url: API_BASE_URL + 'sbps/payment/do_tds2/' + options.uuid,
    method: 'post',
    ...options
  })
}

export const doSbpsSettelementNoTds = options => {
  return request( {
    url: API_BASE_URL + 'sbps/payment/do_settlement/nt/' + options.uuid,
    method: 'post',
    ...options
  })
}

export const doSbpsSettelement = options => {
  return request( {
    url: API_BASE_URL + 'sbps/payment/do_settlement',
    method: 'post',
    ...options
  })
}

export const getUrlTemplateAfterTryApply = options => {
  return request( {
    url: API_BASE_URL + 'sbps/payment/url_template/after_try_apply',
    method: 'get',
    ...options
  })
}

export const recordGenerateTokenFailed = options => {
  return request({
    url: API_BASE_URL + 'sbps/payment/record_generate_token_failed',
    method: 'post',
    ...options
  })
}

export const recordGenerateTds2infoTokenFailed = options => {
  return request({
    url: API_BASE_URL + 'sbps/payment/record_generate_tds2info_token_failed',
    method: 'post',
    ...options
  })
}

export const recordTds2Failed = options => {
  return request({
    url: API_BASE_URL + 'sbps/payment/record_tds2_failed',
    method: 'post',
    ...options
  })
}

export const completePreOrder = options => {
    return request({
        url: API_BASE_URL + 'visitor/pre_order/' + options.uuid + '/complete',
        method: 'post',
        ...options
    })
}

export const getInvoiceRecipient = options => {
  return request({
    url: API_BASE_URL + 'visitor/' + options.eventId + '/invoice/recipient',
    method: 'get',
    ...options
  })
}

export const setInvoiceRecipient = options => {
  return request({
    url: API_BASE_URL + 'visitor/' + options.eventId + '/invoice/recipient',
    method: 'put',
    ...options
  })
}

export const getInvoiceUrl = options => {
  return API_BASE_URL + 'visitor/' + options.eventId + '/invoice'
}

export const getReceiptUrl = options => {
  return API_BASE_URL + 'visitor/' + options.eventId + '/receipt/' + options.locale
}

export const getBundleSite = options => {
  return request({
    url: API_BASE_URL + 'publishbundlesite/' + options.publishId,
    method: 'get',
    ...options
  })
}

export const verifyPrivateBundleSiteAccess = options => {
  console.log(options)
  return request({
    url: API_BASE_URL + 'publishbundlesite/',
    method: 'post',
    ...options
  })
}

export const readyLandingVcube = options => {
  return request({
    url: API_BASE_URL + 'visitor/' + options.eventId + '/readyLandingVcube',
    method: 'get',
    ...options
  })
}

export const doLandingVcube = options => {
  return request({
    url: API_BASE_URL + 'visitor/' + options.eventId + '/doLandingVcube',
    method: 'get',
    ...options
  })
}

export const getLandingUrlZoom = options => {
  return request({
    url: API_BASE_URL + 'visitor/' + options.eventId + '/getLandingUrlZoom',
    method: 'get',
    ...options
  })
}

export const getAllOpenSurveys = options => {
  return request({
    url: API_BASE_URL + 'survey/allOpens/' + options.publishId,
    method: 'get',
    ...options
  })
}
export const doLandingSurveySite = options => {
  return request({
    url: API_BASE_URL + 'survey/doLandingSurveySite/'
      + `${options.eventPublishId}/${options.surveyPublishId}`,
    method: 'get',
    ...options
  })
}

export const getAllOpenQuizzes = options => {
  return request({
    url: API_BASE_URL + 'quiz/allOpens/' + options.publishId,
    method: 'get',
    ...options
  })
}
export const doLandingQuizSite = options => {
  return request({
    url: API_BASE_URL + 'quiz/doLandingQuizSite/'
      + `${options.eventPublishId}/${options.quizPublishId}`,
    method: 'get',
    ...options
  })
}


